
function setupPostActions(locoScroll) {

  $('body').on('click', '.js-loco-scroll', function (e){
    e.preventDefault()
    const target = document.querySelector('#page-content')
    locoScroll.scrollTo(target, { offset: -100})

    setTimeout(function (){
      locoScroll.update()
    }, 1000)

  })

}

export { setupPostActions }
